// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Image/Faq bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-white: #fff;
    --primary-black: #000;
    --primary-grey: #73739a;
    --primary-grey2: #fffc;
    --primary-blue: #6d72f6;
    --primary-green: #08ce8a;
    --primary-black2: #1c1c57;
}


.Faq-section {
  padding: 3rem 20px;
  background-color: #f8f8f8;
}

.Faq-container {
  width: 100%;
  margin: 0 auto;
  max-width: 1200px;
}

.Faq-title-container {
  text-align: center;
  margin-bottom: 40px;
}

.Faq-title-container h1 {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 16px;
  color: var(--primary-black2);
}

.Faq-title-container p {
  width: 100%;
  margin: 0 auto;
  font-size: 18px;
  max-width: 550px;
  color: var(--primary-grey);
}

.Faq-tab-container {
  gap: 20px;
  display: flex;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.Faq-tab-btn-container {
  gap: 20px;
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
}

.Faq-tab-btn-box {
  display: flex;
  width: 100%;
  padding: 20px;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  border-radius: 20px;
  align-items: center;
  color: var(--primary-black2);
  justify-content: space-between;
  background-color: var(--primary-white);
}

.Faq-tab-btn-box.active {
  color: var(--primary-white);
  background-color: var(--primary-blue);
}

.Faq-tab-btn-icon {
  font-size: 14px;
  width: 34px;
  height: 34px;
  display: flex;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  border: 1px solid #bababa;
  color: var(--primary-black2);
}

.Faq-tab-btn-box.active .Faq-tab-btn-icon{
  color: var(--primary-white);
  border-color: var(--primary-white);
  background-color: var(--primary-grey);
}

.Faq-tab-content-box{
  flex: 1 1 100%;
  border-radius: 20px;
  background-color: #fff9;
  backdrop-filter: blur(44px);
  border: 2px solid #ffffff80;
}

.Faq-tab-title-box{
    padding: 30px;
    border-bottom: 2px solid #ffffffa0;
}

.Faq-tab-title-box h2{
    color: var(--primary-black2);
}

.Faq1-content {
  padding: 30px;
  font-size: 16px;
  line-height: 26px;
  color: var(--primary-grey);
}

.Faq-tab-btn{
    display: inline-block;
    position: absolute;
    inset: auto auto 30px 30px;
}

.Faq-tab-btn button{
    border: none;
    overflow: none;
    font-size: 18px;
    cursor: pointer;
    border-radius: 12px;
    padding: 18px 2.5rem;
    transition: 0.3s linear;
    color: var(--primary-white);
    background-color: var(--primary-blue);
}
  
.Faq-tab-btn button:hover {
    transform: translateY(-5px);
    background-color: #555ae6;
    box-shadow: 1px 1px 10px #6d72f6;
}

@media (max-width: 1024px){
    .Faq-tab-container{
        flex-direction: column;
    }
    .Faq-tab-btn{
        position: relative;
        padding-top: 30px;
    }
}

@media (max-width: 480px){
    .Faq1-content {
        text-align: justify;
      }
}`, "",{"version":3,"sources":["webpack://./src/Components/Faq/Faq.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;AAC7B;;;AAGA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,aAAa;EACb,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,yDAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,aAAa;EACb,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;IACI,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,mBAAmB;MACrB;AACN","sourcesContent":[":root {\n    --primary-white: #fff;\n    --primary-black: #000;\n    --primary-grey: #73739a;\n    --primary-grey2: #fffc;\n    --primary-blue: #6d72f6;\n    --primary-green: #08ce8a;\n    --primary-black2: #1c1c57;\n}\n\n\n.Faq-section {\n  padding: 3rem 20px;\n  background-color: #f8f8f8;\n}\n\n.Faq-container {\n  width: 100%;\n  margin: 0 auto;\n  max-width: 1200px;\n}\n\n.Faq-title-container {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.Faq-title-container h1 {\n  font-size: 36px;\n  font-weight: 700;\n  margin-bottom: 16px;\n  color: var(--primary-black2);\n}\n\n.Faq-title-container p {\n  width: 100%;\n  margin: 0 auto;\n  font-size: 18px;\n  max-width: 550px;\n  color: var(--primary-grey);\n}\n\n.Faq-tab-container {\n  gap: 20px;\n  display: flex;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-image: url(./Image/Faq\\ bg.png);\n}\n\n.Faq-tab-btn-container {\n  gap: 20px;\n  display: flex;\n  flex: 1 1 100%;\n  flex-direction: column;\n}\n\n.Faq-tab-btn-box {\n  display: flex;\n  width: 100%;\n  padding: 20px;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  font-size: 18px;\n  font-weight: 600;\n  border-radius: 20px;\n  align-items: center;\n  color: var(--primary-black2);\n  justify-content: space-between;\n  background-color: var(--primary-white);\n}\n\n.Faq-tab-btn-box.active {\n  color: var(--primary-white);\n  background-color: var(--primary-blue);\n}\n\n.Faq-tab-btn-icon {\n  font-size: 14px;\n  width: 34px;\n  height: 34px;\n  display: flex;\n  border-radius: 50%;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #bababa;\n  color: var(--primary-black2);\n}\n\n.Faq-tab-btn-box.active .Faq-tab-btn-icon{\n  color: var(--primary-white);\n  border-color: var(--primary-white);\n  background-color: var(--primary-grey);\n}\n\n.Faq-tab-content-box{\n  flex: 1 1 100%;\n  border-radius: 20px;\n  background-color: #fff9;\n  backdrop-filter: blur(44px);\n  border: 2px solid #ffffff80;\n}\n\n.Faq-tab-title-box{\n    padding: 30px;\n    border-bottom: 2px solid #ffffffa0;\n}\n\n.Faq-tab-title-box h2{\n    color: var(--primary-black2);\n}\n\n.Faq1-content {\n  padding: 30px;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--primary-grey);\n}\n\n.Faq-tab-btn{\n    display: inline-block;\n    position: absolute;\n    inset: auto auto 30px 30px;\n}\n\n.Faq-tab-btn button{\n    border: none;\n    overflow: none;\n    font-size: 18px;\n    cursor: pointer;\n    border-radius: 12px;\n    padding: 18px 2.5rem;\n    transition: 0.3s linear;\n    color: var(--primary-white);\n    background-color: var(--primary-blue);\n}\n  \n.Faq-tab-btn button:hover {\n    transform: translateY(-5px);\n    background-color: #555ae6;\n    box-shadow: 1px 1px 10px #6d72f6;\n}\n\n@media (max-width: 1024px){\n    .Faq-tab-container{\n        flex-direction: column;\n    }\n    .Faq-tab-btn{\n        position: relative;\n        padding-top: 30px;\n    }\n}\n\n@media (max-width: 480px){\n    .Faq1-content {\n        text-align: justify;\n      }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
